<wr-base-dialog *ngIf="form as form" title="Anhänge bearbeiten" [submitResponse]="onSubmit">
  <hau-form [formGroup]="form">
    <hau-form-field>
      <wr-multi-attachment-control formControlName="attachments"></wr-multi-attachment-control>
    </hau-form-field>
  </hau-form>
</wr-base-dialog>
